import { render, staticRenderFns } from "./TextWithRefs.vue?vue&type=template&id=325132ce&"
import script from "./TextWithRefs.vue?vue&type=script&lang=js&"
export * from "./TextWithRefs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports